import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * Asks which machine a spare-parts sheet belongs to.
 *
 * A maker's parts list is written for ONE machine, so the machine is named on
 * the catalogue cover and never repeated on the rows — the supplied Scania
 * list is exactly that: 30 parts, no maker column. Those sheets used to be
 * rejected row by row for "missing Equipment Name, Equipment Maker".
 *
 * Rather than making the user retype 30 rows into the MPS template, the sheet
 * is read as-is and the machine is supplied once, here, before the import runs.
 * Maker is the only hard requirement: it is what the uniqueness rule scopes a
 * part number to, so without it two unrelated "pos 1" parts would collide.
 */
@Component({
  selector: 'app-spare-equipment-prompt',
  templateUrl: './spare-equipment-prompt.component.html',
  styleUrls: ['./spare-equipment-prompt.component.css'],
})
export class SpareEquipmentPromptComponent {
  /** How many parts are waiting on this answer. */
  @Input() rowCount = 0;

  /** Shown so the user can see the import understood the file. */
  @Input() fileName = '';

  @Input() busy = false;

  equipmentName = '';
  equipmentManufacturer = '';
  equipmentModel = '';
  equipmentSerialNo = '';
  sfiCode = '';

  @Output() confirm = new EventEmitter<{
    equipmentName: string;
    equipmentManufacturer: string;
    equipmentModel: string;
    equipmentSerialNo: string;
    sfiCode: string;
  }>();
  @Output() cancel = new EventEmitter<void>();

  get canImport(): boolean {
    return (
      !!this.equipmentName.trim() &&
      !!this.equipmentManufacturer.trim() &&
      !this.busy
    );
  }

  submit(): void {
    if (!this.canImport) return;
    this.confirm.emit({
      equipmentName: this.equipmentName.trim(),
      equipmentManufacturer: this.equipmentManufacturer.trim(),
      equipmentModel: this.equipmentModel.trim(),
      equipmentSerialNo: this.equipmentSerialNo.trim(),
      sfiCode: this.sfiCode.trim(),
    });
  }
}
